import React, { FC } from 'react';
import { DatePicker, DatePickerProps } from 'formik-antd';
import moment from 'moment';

export const AppDatePicker: FC<DatePickerProps> = (props: DatePickerProps) => (
  <DatePicker
    format="DD-MM-YYYY"
    placeholder="DD-MM-YYYY"
    style={{ width: '100%' }}
    disabledDate={(d) => !d || d.isAfter(moment())}
    {...props}
  />
);
